<span [hidden]="forceHideLoadingIndicator || showLoader <= 0 || (showLoader > 0 && showSecondaryLoadingMask)" class="loading"></span>
<span [hidden]="forceHideLoadingIndicator || !showSecondaryLoadingMask"></span>
<input type="hidden" [value]="showLoader <= 0" name="loader1field" />
<input type="hidden" [value]="!showSecondaryLoadingMask" name="loader2field" />
<router-outlet></router-outlet>
